<template>
    <i class="scratch-icon icon-silver">s</i>
</template>

<script>
    export default {
        name: 'IconSilver'
    }
</script>

<style scoped>
@import "../assets/scratch.css";
.icon-silver {
    background: url("../assets/icons/silver.png") no-repeat;
}
</style>